<template>
  <div ref="modal" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">{{ label }}</label>
            <input
              v-model="inputValue"
              type="text"
              class="form-control"
              @keyup.enter="successEvent"
              ref="input"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button type="button" class="btn btn-primary" @click="successEvent">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const bootstrap = require("bootstrap");

export default {
  name: "PromptModal",
  props: {
    title: {
      type: String,
      default: "Input required",
    },
    label: {
      type: String,
      default: "Name",
    },
  },
  data() {
    return {
      myModal: undefined,
      inputValue: "",
    };
  },
  emits: ["success"],
  methods: {
    showModal(defaultValue = "") {
      this.inputValue = defaultValue;
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
      setTimeout(() => {
        if (this.$refs.input) this.$refs.input.focus();
      }, 500);
    },
    successEvent() {
      if (!this.inputValue) return;
      this.myModal.hide();
      this.$emit("success", this.inputValue);
      this.inputValue = "";
    },
  },
};
</script>
